// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/index.scss'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    // document.dispatchEvent(new Event('render-event'))  //会打包失败
    document.dispatchEvent(new Event('custom-render-trigger'))
  },
})



// WEBPACK FOOTER //
// ./src/main.js